import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { ApiUrlInjectionToken } from '@mitsubishi/shared/data-access';

import {
  CombRequest,
  CombResponse,
  ComputeRequest,
  ComputeResponse,
  ConfigurationRequest,
  ConfigurationResponse,
  CsResponse,
  DatasheetSectionsAvailability,
  FreestDatasheetPdfRequest,
  FreestFieldMappingDto,
  ResponseDatasheet,
  StartResponse,
  UomSystem,
} from '../models/chiller-free-st.model';

@Injectable({
  providedIn: 'root',
})
export class ChillerFreeStService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(ApiUrlInjectionToken) + '/chiller-freest';

  // projectId e obbligatorio sugli endpoint che chiamano ClimaVeneta: il BE lo usa per risolvere
  // l'ambiente Elca del progetto sul login FreeST verso elcatech realtime.
  getStart(projectId: string): Observable<StartResponse> {
    return this.http.get<StartResponse>(`${this.baseUrl}/start`, { params: { projectId } });
  }

  getCompressorSeries(projectId: string, serieId: string): Observable<CsResponse[]> {
    return this.http.get<CsResponse[]>(`${this.baseUrl}/cs/${serieId}`, { params: { projectId } });
  }

  getFieldMappings(uomSystem: UomSystem): Observable<FreestFieldMappingDto[]> {
    return this.http.get<FreestFieldMappingDto[]>(`${this.baseUrl}/field-mappings`, {
      params: { uomSystem },
    });
  }

  compute(request: ComputeRequest): Observable<ComputeResponse> {
    return this.http.post<ComputeResponse>(`${this.baseUrl}/compute`, request);
  }

  getCombinations(projectId: string, request: CombRequest): Observable<CombResponse[]> {
    return this.http.post<CombResponse[]>(`${this.baseUrl}/comb`, request, { params: { projectId } });
  }

  generateDatasheetPdf(projectId: string, request: FreestDatasheetPdfRequest): Observable<ResponseDatasheet> {
    return this.http.post<ResponseDatasheet>(`${this.baseUrl}/datasheet/pdf`, request, { params: { projectId } });
  }

  getDatasheetPdfAvailableSections(
    projectId: string,
    request: FreestDatasheetPdfRequest
  ): Observable<DatasheetSectionsAvailability> {
    return this.http.post<DatasheetSectionsAvailability>(`${this.baseUrl}/datasheet/availability`, request, {
      params: { projectId },
    });
  }

  saveConfiguration(request: ConfigurationRequest): Observable<ConfigurationResponse> {
    return this.http.post<ConfigurationResponse>(`${this.baseUrl}/configuration`, request);
  }

  getConfiguration(id: string): Observable<ConfigurationRequest> {
    return this.http.get<ConfigurationRequest>(`${this.baseUrl}/configuration/${id}`);
  }
}
